let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Dn2K")).then(() => parcelRequire('e0Ipq'));